module.exports = __webpack_public_path__ + "img/1 (82).c6a4780c.png";